import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=eec3a382&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=ts"
export * from "./CommonTable.vue?vue&type=script&lang=ts"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=eec3a382&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec3a382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eec3a382')) {
      api.createRecord('eec3a382', component.options)
    } else {
      api.reload('eec3a382', component.options)
    }
    module.hot.accept("./CommonTable.vue?vue&type=template&id=eec3a382&scoped=true", function () {
      api.rerender('eec3a382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/CommonTable.vue"
export default component.exports